import { Loading } from '@/layouts/loading';
import { createFileRoute } from '@tanstack/react-router';
import Component from './-module-components/component';

export const Route = createFileRoute('/manager/_layout')({
    component: Component,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
})